import React, { Component, Fragment } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './applySociety.scss';
import HTTP from '../../script/service';
import Util from '../../script/util';
import { _new_nim_window } from '../../store/Action';

class ApplyClassly extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      selectList: [],
    };
  }
  componentDidMount() {
    if (this.props.mode == 'content') {
      this.getPageData();
    }
  }
  showModal = () => {
    this.getPageData();
  };
  hideModal = () => {
    this.setState({ visible: false }, () => {
      this.props.nextEvent && this.props.nextEvent();
    });
  };
  getPageData = () => {
    HTTP._get_recommend_sociaty_list().then((res) => {
      if (res.code === 200) {
        this.setState({ visible: true, selectList: res.data });
      } else {
        message.warning(res.message);
      }
    });
  };
  // 选择加入公会
  handleClickItem = (select) => {
    this.setState({ selectId: select });
  };
  // 打开聊天框
  handleOpenChat = (uid) => {
    let account = Util.$analyToAccount(uid);
    let to = {
      id: `p2p-${account}`,
      scene: 'p2p',
      account: account,
    };
    //标注
    _new_nim_window(to);
    this.hideModal();
  };
  // 加入公会
  joinGuild = () => {
    HTTP._apply_join_sociaty({
      uid: this.props.base.uid,
      inviteCode: this.state.selectId,
    }).then((res) => {
      if (res.code == 200) {
        message.success('已提交公会审核');
        this.hideModal();
      } else {
        message.error(res.message);
      }
    });
  };

  // 加入公会要求
  openSocietyRule = () => {
    Modal.info({
      title: '加入公会',
      icon: null,
      closable: true,
      content: (
        <ol>
          <li>
            1、申请加入公会前，请先向公会负责人了解清楚公会规则；签约成功后，应在签约公会旗下的聊天室内提供服务；
          </li>
          <br />
          <li>
            2、加入公会后，大神的陪玩订单收益和礼物收益不变，另外提现手续费由10%下降至5%；
          </li>
          <br />
          <li>3、入会时间不满45天无法自主申请退会。</li>
        </ol>
      ),
      className: 'daidai-confirm-style daidai-btns-max join-society-modal-info',
      centered: true,
      okText: '我知道了',
    });
  };

  render() {
    const { mode, user } = this.props;
    const { visible, selectList, selectId } = this.state;
    const contentHtml = (
      <Scrollbar className="apply-scroll-bar" style={{ height: '440px' }}>
        <div
          className="iscroll-html"
          id="apply-scroll-bar"
          style={{ padding: '20px 50px' }}
        >
          <div className="applySociety-box">
            <div className="gh-list" style={{ padding: mode == 'content' ? 0 : '16px' }}>
              {selectList && selectList.length
                ? selectList.map((item, index) => (
                    <div
                      key={index}
                      className="gh-item"
                      style={
                        !!item.skinPC
                          ? {
                              backgroundImage: `url(${Util.transImgUrl(item.skinPC, '278x70')})`,
                            }
                          : {}
                      }
                    >
                      {!!item.cornerMark && (
                        <span className="mark-icon">
                          <img
                            src={Util.transImgUrl(item.cornerMark, '30x30')}
                            alt=""
                          />
                        </span>
                      )}
                      <div className="cover">
                        <img
                          src={Util.transImgUrl(item.icon)}
                          alt={item.name}
                        />
                      </div>
                      <div className="gh-info">
                        <h3 className="gh-title">{item.name}</h3>
                        {!!item.sociatyPreUid && (
                          <p className="gh-contact">
                            <span className="pre-avatar">
                              <img
                                src={Util.transImgUrl(
                                  item.sociatyPreAvatar,
                                  '20x20'
                                )}
                                alt={item.sociatyPreNickname}
                              />
                            </span>
                            <span className="pre-uid">
                              {item.sociatyPreUid}
                            </span>
                          </p>
                        )}
                      </div>
                      {!!item.sociatyPreUid && (
                        <button
                          className="chat-btn"
                          onClick={() =>
                            this.handleOpenChat(item.sociatyPreUid)
                          }
                        />
                      )}
                      
                      <button
                        className="join-btn"
                        onClick={() => this.handleClickItem(item.code)}
                      >
                        加入
                      </button>

                      {selectId === item.code ? (
                        <div className="select-active">
                          <h4 className="text">确认加入 {item.name} 公会</h4>
                          <div className="btn-wrap">
                            <button
                              className="join-btn cancel"
                              onClick={() => this.handleClickItem(null)}
                            >
                              取消
                            </button>
                            <button
                              className="join-btn active"
                              onClick={this.joinGuild}
                            >
                              加入
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </Scrollbar>
    );
    return (
      <Fragment>
        {mode == 'content' ? (
          <Fragment>{contentHtml}</Fragment>
        ) : (
          <Modal
            open={visible}
            width="600px"
            wrapClassName="daidai-modal-style has-top-border join-society-modal"
            centered={true}
            title={
              <span>
                加入公会{' '}
                <QuestionCircleOutlined onClick={this.openSocietyRule} />
              </span>
            }
            footer={null}
            keyboard={false}
            maskClosable={false}
            destroyOnHidden={true}
            onCancel={this.hideModal}
          >
            <div>{contentHtml}</div>
          </Modal>
        )}
      </Fragment>
    );
  }
}
ApplyClassly.defaultProps = {
  mode: 'content', // content || modal
};

export default withRouter(ApplyClassly, { withRef: true });
